// Browser auto-translate (Chrome/Google Translate) moves React-rendered text
// nodes into <font> wrappers. React's next removeChild/insertBefore on those
// nodes then throws NotFoundError and the error boundary replaces the page.
// Skip the mutation instead, as suggested in facebook/react#11538:
// https://github.com/facebook/react/issues/11538#issuecomment-417504600
let installed = false;

export function installDomMutationGuard() {
  if (installed || typeof Node !== "function") return;
  installed = true;

  const { removeChild, insertBefore } = Node.prototype;

  Node.prototype.removeChild = function <T extends Node>(this: Node, child: T) {
    if (child.parentNode !== this) return child;
    return removeChild.call(this, child) as T;
  };

  Node.prototype.insertBefore = function <T extends Node>(
    this: Node,
    node: T,
    child: Node | null,
  ) {
    if (child && child.parentNode !== this) return node;
    return insertBefore.call(this, node, child) as T;
  };
}
